import LegendText from './LegendText'

export default LegendText
